import { PageContentProcessTabs } from 'framework/ViewTypes/components';
import { ActiveProcesses } from 'framework/ViewTypes/embeddable';
import type { ActiveProcessesProps } from 'framework/ViewTypes/embeddable';

const ApplicationActiveProcessesPanel = (props: ActiveProcessesProps) => (
  <PageContentProcessTabs
    tabs={[
      {
        id: 'active-processes',
        name: 'Active processes',
        panel: <ActiveProcesses {...props} />,
      },
    ]}
  />
);

export default ApplicationActiveProcessesPanel;
